module.exports = __webpack_public_path__ + "static/imageTwo@2x-f35046048cff197814277319d3cec987.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/media/images/pages/features/handoff/imageTwo@2x.jpg
// module id = 2607
// module chunks = 168707334958949